import React from 'react'
import "../deal_week/DealWeek.css"
const DealWeek = () => {
  return (
    <>
     <section id="deal_week">
    <div class="container">
      <div class="row justify-content-space-between">
        <div class="col-lg-3">
          <h1>Deal of the week</h1>
        </div>
        <div class="col-lg-4">
            <ul class="deal_week_date">
              <li><p>45 <br/>Days</p></li>
              <li class="deal_week_date-no"><p>20<br/>Hour</p></li>
              <li><p>30<br/>Min</p></li>
              <li class="deal_week_date-no"><p>30<br/>Sec</p></li>
            </ul>
        </div>
        <div class="col-lg-12 pt-3">
          <div class="deal_week_main">
            <div class="deal_week_text">
              <h1>Fresh vegetable & <br/>
                Fruit basket</h1>
              <p>Fresh Packed to order</p>
              <button class="shop_now">shop now</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
    </>
  )
}

export default DealWeek